module.exports = __webpack_public_path__ + "static/media/photo_8.d2bf15f5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/gallery/photo_8.jpg
// module id = 1641
// module chunks = 0